/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Ai_Still_RunningInputs */

const cs_blog_ai_still_running = /** @type {(inputs: Blog_Ai_Still_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úloha možná stále běží — zkontrolujte notifikace nebo stránku brzy obnovte.`)
};

const en_blog_ai_still_running = /** @type {(inputs: Blog_Ai_Still_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job may still be running — check notifications or refresh shortly.`)
};

/**
* | output |
* | --- |
* | "Job may still be running — check notifications or refresh shortly." |
*
* @param {Blog_Ai_Still_RunningInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_still_running = /** @type {((inputs?: Blog_Ai_Still_RunningInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_Still_RunningInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_still_running(inputs)
	return cs_blog_ai_still_running(inputs)
});